
import Settings from './reducers';

export { receivedBlogSettings } from './actions';
export {
  getBlogSettings,
  getBlogOverviewLink,
  getBlogOverviewLinkLabel,
  getBlogReadMoreLabel,
  getBlogShareLabel,
  getBlogLoadMoreLabel,
  getBlogLatestArticlesLabel,
} from './selectors';

export default Settings;
